export function createEmptyGridData(): string[][] {
  return [['']]
}

export function buildRangesFromGridData(gridData: string[][]): string {
  if (!gridData.length) {
    return '0:0'
  }

  if (gridData.length === 1) {
    return '0:0'
  }

  return `1:${gridData.length - 1}`
}

export function countDataRowsFromRanges(ranges?: string | null): number | null {
  if (!ranges) {
    return null
  }

  let total = 0

  for (const segment of ranges.split(',')) {
    const trimmed = segment.trim()

    if (!trimmed) {
      continue
    }

    const [startRaw, endRaw] = trimmed.split(':')
    const start = Number(startRaw)
    const end = Number(endRaw)

    if (Number.isNaN(start) || Number.isNaN(end)) {
      continue
    }

    if (start === 0 && end === 0) {
      return 0
    }

    total += Math.max(0, end - start + 1)
  }

  return total
}
